<template>
  <div class="content">
    <CustomTable ref="CustomTable" v-loading="loading" @init="init" @handelBtnClick="handelBtnClick"
      @handelTableChange="handelTableChange" @handelTableClick="handelTableClick" :filterData="filterData"
      :headerData="headerData" :btnsData="btnsData" :data="data" :pagination="pagination">
      <el-table-column label="操作" fixed="right" align="center" width="100px">
        <template slot-scope="scope">
          <el-link @click="handelTableClick(scope.row, 'edit')">编辑</el-link>
          <el-popconfirm title="确定删除吗？" @confirm="handelTableClick(scope.row, 'delete')">
            <el-link slot="reference">删除</el-link>
          </el-popconfirm>
        </template>
      </el-table-column>
    </CustomTable>
    <CustomUpload ref="CustomUpload" :url="uploadUrl" :hideUpload="true" @handelChange="handelChange" />
    <el-dialog :title="createdType == 'add' ? '新增个人会员' : '修改个人会员（密码留空则不修改）'" :visible.sync="dialogVisible" width="800px"
      :close-on-click-modal="false">
      <CustomForm ref="CustomForm" :data="addFormData" @change="handelForm" />
    </el-dialog>
  </div>
</template>
  
<script>
import CustomForm from "@/components/custom/CustomForm";
import CustomTable from "@/components/custom/CustomTable";
import CustomUpload from "@/components/custom/CustomUpload";
import config from "@/request/config";
export default {
  components: { CustomForm, CustomTable, CustomUpload },
  data() {
    return {
      uploadUrl: this.$api.Members.personalImport,
      filterData: [
        { label: "用户名", prop: "userName", type: "input" },
        { label: "会员号", prop: "memberNum", type: "input" },
        { label: "会员单位名称", prop: "unitId", type: "input" },
        { label: "姓名", prop: "name", type: "input" },
        // { label: "政治风貌", prop: "political", type: "input" },
        // { label: "技术职称", prop: "title", type: "input" },
        // { label: "学历", prop: "edu", type: "input" },
        // { label: "邮箱", prop: "email", type: "input" },
        {
          label: "审核状态",
          prop: "auditingStatus",
          type: "select",
          value: "",
          opt: [
            { label: "待审核", value: "PADDING" },
            { label: "通过", value: "PASS" },
            { label: "不通过", value: "FAIL" },
          ],
        },
        {
          label: "状态",
          prop: "status",
          type: "select",
          value: "",
          opt: [
            { label: "启用", value: true },
            { label: "禁用", value: false },
          ],
        },
        {
          label: "专家",
          prop: "expert",
          type: "select",
          value: "",
          opt: [
            { label: "是", value: true },
            { label: "否", value: false },
          ],
        },
        {
          label: "认缴 (元)",
          prop: "promisePay",
          type: "select",
          value: "",
          opt: [
            { label: "是", value: true },
            { label: "否", value: false },
          ],
        },
      ],
      headerData: [
        { label: "排序", prop: "sortOrder" },
        { label: "会员号", prop: "memberNum" },
        { label: "用户名", prop: "userName" },
        { label: "姓名", prop: "name" },
        { label: "身份证号码", prop: "idCard" },
        // { label: "邮箱", prop: "email" },
        { label: "用户类型", prop: "unitType" },
        { label: "所属单位", prop: "unitName" },
        { label: "认缴金额 (元)", prop: "promisePayAmount" },
        { label: "认缴", prop: "promisePay", type: "switch" },
        { label: "预备", prop: "perMember", type: "switch" },
        { label: "缴费", prop: "pay", type: "switch" },
        { label: "专家", prop: "expert", type: "switch" },
        {
          label: "审核状态",
          prop: "auditingStatus",
          type: "audit",
          opt: [
            { label: "通过", value: "PASS" },
            { label: "不通过", value: "FAIL", check: true },
          ],
        },
        { label: "状态", prop: "status", type: "switch" },
      ],
      btnsData: [
        { label: "新增", value: "add", type: "primary" },
        { label: "导入", value: "improt" },
        { label: "导出", value: "export" },
        { label: "下载导入模板", value: "exportTemplate" },
      ],
      data: [],
      addFormData: [
        {
          label: "用户名",
          prop: "userName",
          type: "input",
          value: "",
          required: true,
          span: 24,
        },
        {
          label: "密码",
          prop: "password",
          type: "input",
          value: "",
          required: true,
          span: 24,
        },
        {
          label: "个人照片",
          prop: "img",
          type: "upload",
          value: [],
          required: false,
          span: 24,
        },
        {
          label: "会员单位名称",
          prop: "unitName",
          type: "input",
          value: "",
          required: false,
          span: 24,
        },
        {
          label: "姓名",
          prop: "name",
          type: "input",
          value: "",
          required: true,
          span: 12,
        },
        {
          label: "身份证号码",
          prop: "idCard",
          type: "input",
          value: "",
          required: true,
          span: 12,
        },
        {
          label: "性别",
          prop: "sex",
          type: "select",
          value: "",
          required: false,
          opt: [
            { label: "男", value: "M" },
            { label: "女", value: "F" },
          ],
          span: 12,
        },
        {
          label: "政治风貌",
          prop: "political",
          type: "select",
          value: "",
          required: false,
          opt: [
            { label: "党员", value: "党员" },
            { label: "预备党员", value: "预备党员" },
            { label: "群众", value: "群众" },
          ],
          span: 12,
        },
        {
          label: "出生年月",
          prop: "dob",
          type: "date",
          value: "",
          required: false,
          span: 12,
        },
        {
          label: "技术职称",
          prop: "title",
          type: "inputSelect",
          value: "",
          required: false,
          opt: [
            { label: "教授或教授级高级工程师", value: "教授或教授级高级工程师" },
            { label: "正高级职称", value: "正高级职称" },
            { label: "副高级职称", value: "副高级职称" },
            { label: "中级职称", value: "中级职称" },
            { label: "初级职称", value: "初级职称" }
          ],
          span: 12,
        },
        {
          label: "学历",
          prop: "edu",
          type: "select",
          value: "",
          required: false,
          opt: [
            { label: "研究生", value: "研究生" },
            { label: "本科", value: "本科" },
            { label: "中专/高中", value: "中专/高中" },
            { label: "初中", value: "初中" },
            { label: "小学", value: "小学" },
          ],
          span: 12,
        },
        {
          label: "联系电话",
          prop: "mobile",
          type: "input",
          value: "",
          required: true,
          span: 12,
        },
        {
          label: "办公室电话",
          prop: "officeNum",
          type: "input",
          value: "",
          required: false,
          span: 24,
        },
        // {
        //   label: "邮箱",
        //   prop: "email",
        //   type: "input",
        //   value: "",
        //   required: true,
        //   span: 12,
        // },
        {
          label: "简历",
          prop: "resume",
          type: "editor",
          value: "",
          required: false,
          span: 24,
        },
        {
          label: "排序",
          prop: "sortOrder",
          value: "0",
          type: "number",
          required: false,
          span: 12,
        },
      ],
      loading: false,
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
      selectData: {},
      dialogVisible: false,
      createdType: "",
      queryParams: {}
    };
  },
  methods: {
    handelChange() {
      this.$refs.CustomTable.search();
    },
    handelTableChange(data) {
      let url = "";
      let params = {};
      let ajaxType = "get";
      switch (data.prop) {
        case "status":
          url = this.$api.Members.personalStatus;
          params = {
            status: data.data.status ? "active" : "inactive",
          };
          break;
        case "auditingStatus":
          ajaxType = "post";
          url = this.$api.Members.personalAuditing;
          params = data.value;
          break;
        case "perMember":
          url = this.$api.Members.preMember;
          params = {
            isPre: data.data.perMember,
          };
          break;
        case "pay":
          url = this.$api.Members.ispay;
          params = {
            isPay: data.data.pay,
          };
          break;
        case "expert":
          url = this.$api.Members.expertUpdate;
          params = {
            expert: data.data.expert,
          };
          break;
        case "promisePay":
          url = this.$api.Members.promisePay;
          params = {
            promisePay: data.data.promisePay,
          };
          break;
      }
      this.$https[ajaxType](url + data.data.id, params).then((res) => {
        this.$message.success("修改成功");
        this.$refs.CustomTable.search();
      });
    },
    handelForm(data) {
      if (!Object.keys(data).length) {
        this.dialogVisible = false;
        return;
      }
      const url =
        this.createdType == "add"
          ? this.$api.Members.personalAdd
          : this.$api.Members.personalUpdate + this.selectData.id;
      this.$https.post(url, { ...data, img: data.img[0] }).then((res) => {
        this.$message.success(
          this.createdType == "add" ? "新增正常" : "修改成功"
        );
        this.dialogVisible = false;
        this.$refs.CustomTable.search();
      });
    },
    handelTableClick(data, type) {
      this.createdType = type;
      switch (type) {
        case "delete":
          this.$https
            .post(this.$api.Members.personalDelete + data.id)
            .then((res) => {
              this.$message.success("删除成功");
              this.$refs.CustomTable.search();
            });
          break;
        case "edit":
          this.selectData = data;
          this.$https
            .get(this.$api.Members.personalDetails + data.id)
            .then((res) => {
              this.addFormData = this.addFormData.map((el) => {
                return Object.assign(el, {
                  required: el.prop == "password" ? false : el.required,
                  disabled: el.prop == "unitName",
                  value:
                    el.prop == "img"
                      ? res[el.prop]
                        ? [res[el.prop]]
                        : []
                      : res[el.prop] || el.value,
                });
              });
              this.dialogVisible = true;
            });
          break;
      }
    },
    handelBtnClick(type) {
      this.createdType = type;
      switch (type) {
        case "add":
          this.addFormData = [
            {
              label: "用户名",
              prop: "userName",
              type: "input",
              value: "",
              required: true,
              span: 24,
            },
            {
              label: "密码",
              prop: "password",
              type: "input",
              value: "",
              required: true,
              span: 24,
            },
            {
              label: "个人照片",
              prop: "img",
              type: "upload",
              value: [],
              required: false,
              span: 24,
            },
            {
              label: "会员单位名称",
              prop: "unitName",
              type: "input",
              value: "",
              required: false,
              span: 24,
            },
            {
              label: "姓名",
              prop: "name",
              type: "input",
              value: "",
              required: true,
              span: 12,
            },
            {
              label: "身份证号码",
              prop: "idCard",
              type: "input",
              value: "",
              required: true,
              span: 12,
            },
            {
              label: "性别",
              prop: "sex",
              type: "select",
              value: "",
              required: false,
              opt: [
                { label: "男", value: "M" },
                { label: "女", value: "F" },
              ],
              span: 12,
            },
            {
              label: "政治风貌",
              prop: "political",
              type: "select",
              value: "",
              required: false,
              opt: [
                { label: "党员", value: "党员" },
                { label: "预备党员", value: "预备党员" },
                { label: "群众", value: "群众" },
              ],
              span: 12,
            },
            {
              label: "出生年月",
              prop: "dob",
              type: "date",
              value: "",
              required: false,
              span: 12,
            },
            {
              label: "技术职称",
              prop: "title",
              type: "inputSelect",
              value: "",
              required: false,
              opt: [
                { label: "教授或教授级高级工程师", value: "教授或教授级高级工程师" },
                { label: "正高级职称", value: "正高级职称" },
                { label: "副高级职称", value: "副高级职称" },
                { label: "中级职称", value: "中级职称" },
                { label: "初级职称", value: "初级职称" }
              ],
              span: 12,
            },
            {
              label: "学历",
              prop: "edu",
              type: "select",
              value: "",
              required: false,
              opt: [
                { label: "研究生", value: "研究生" },
                { label: "本科", value: "本科" },
                { label: "中专/高中", value: "中专/高中" },
                { label: "初中", value: "初中" },
                { label: "小学", value: "小学" },
              ],
              span: 12,
            },
            {
              label: "联系电话",
              prop: "mobile",
              type: "input",
              value: "",
              required: true,
              span: 12,
            },
            {
              label: "办公室电话",
              prop: "officeNum",
              type: "input",
              value: "",
              required: false,
              span: 24,
            },
            // {
            //   label: "邮箱",
            //   prop: "email",
            //   type: "input",
            //   value: "",
            //   required: true,
            //   span: 12,
            // },
            {
              label: "简历",
              prop: "resume",
              type: "editor",
              value: "",
              required: false,
              span: 24,
            },
            {
              label: "排序",
              prop: "sortOrder",
              value: "0",
              type: "number",
              required: false,
              span: 12,
            },
          ];
          this.dialogVisible = true;
          break;
        case "improt":
          this.$refs.CustomUpload.handleCallUpload();
          break;
        case "export":
          this.$https
            .postForm(
              this.$api.Members.personalExport,
              this.queryParams,
            )
            .then((res) => {
              let a = document.createElement("a");
              //ArrayBuffer 转为 Blob
              let blob = new Blob([res], { type: "application/vnd.ms-excel" });
              let objectUrl = URL.createObjectURL(blob);
              a.setAttribute("href", objectUrl);
              a.setAttribute("download", "个人会员名单.xlsx");
              a.click();
            });
          break;
        case "exportTemplate":
          // 创建一个<a></a>标签
          const a = document.createElement("a");
          a.href = window.location.pathname + "personalTemplate.xlsx";
          a.download = "个人会员导入模板.xlsx";
          // 障眼法藏起来a标签
          a.style.display = "none";
          // 将a标签追加到文档对象中
          document.body.appendChild(a);
          // 模拟点击了<a>标签,会触发<a>标签的href的读取,浏览器就会自动下载了
          a.click();
          // 一次性的,用完就删除a标签
          a.remove();
          break;
      }
    },
    init(data) {
      this.loading = true;
      let params = data;
      if (params && Object.keys(params).includes("status")) {
        params.status = params.status ? "active" : "inactive";
      }
      params.current -= 1;
      this.queryParams = params
      this.$https.get(this.$api.Members.personalList, params).then((res) => {
        this.pagination = {
          pageSize: res.pageSize,
          current: res.currentPage + 1,
          total: res.count,
        };
        this.data = res.data
          ? res.data.map((el) => {
            return Object.assign(el, {
              status: el.status == "active" ? true : false,
              auditingStatus:
                el.auditingStatus == "PADDING" ? "" : el.auditingStatus,
              unitType: el.unitId ? "单位个人会员" : "个人会员",
              perMemberDisabled: el.unitId ? true : false,
              perMemberName: el.unitId ? "根据单位" : "",
              payDisabled: el.unitId ? true : false,
              payName: el.unitId ? "根据单位" : "",
              auditingStatusDisabled: el.unitId ? true : false,
              auditingStatusName:
                el.auditingStatus == "PADDING"
                  ? "待审核"
                  : el.auditingStatus == "FALL"
                    ? "不通过"
                    : "通过",
            });
          })
          : [];
        this.loading = false;
      });
    },
  },
};
</script>
  
<style lang="scss" scoped>
.content {
  position: relative;
  width: 100%;
  overflow: hidden;
}

/deep/.el-dialog__body {
  padding: 0;
}
</style>